import { Box, Button, Typography } from '@mui/material';
import messages from './messages';
import { useIntl, FormattedMessage } from 'react-intl';
import { useActivateRoute } from '~/hooks/api/useActivateRoute';
import EnableIcon from '@mui/icons-material/CheckCircleOutlined';
import { grey } from '@mui/material/colors';
import DisabledIcon from '@mui/icons-material/Block';
import styles from './styles.module.css';
import { useSnackbar } from '~/containers/Snackbar/SnackbarContext';

type ActivateRouteButtonProps = {
  routeId: number;
};
const ActivateRouteButton = (props: ActivateRouteButtonProps) => {
  const intl = useIntl();
  const { showSnackbar } = useSnackbar();
  const activateRouteMutation = useActivateRoute(props.routeId, {
    onSuccess: () => {
      showSnackbar({
        message: intl.formatMessage(messages.enableSuccess),
      });
    },
    onError: () => {
      showSnackbar({
        message: intl.formatMessage(messages.enableFailure),
      });
    },
  });
  return (
    <Box
      className={styles['disabled-content']}
      sx={{
        overflow: 'hidden',
        height: '50vh',
      }}
    >
      <DisabledIcon
        sx={{
          width: '10vh',
          height: '10vh',
          color: grey[400],
          margin: '2rem auto 1.5rem auto',
          display: 'block',
        }}
      />
      <Typography
        variant="h4"
        component="h1"
        sx={{
          textAlign: 'center',
          marginBottom: '1.5rem',
        }}
      >
        <FormattedMessage {...messages.isDisabled} />
      </Typography>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Button
          onClick={() => {
            activateRouteMutation.mutate();
          }}
          color="secondary"
          variant="contained"
          startIcon={<EnableIcon />}
          disabled={activateRouteMutation.isPending}
        >
          {intl.formatMessage(messages.enableButton)}
        </Button>
      </Box>
    </Box>
  );
};

export default ActivateRouteButton;
